import { Flex } from '@ifood/pomodoro-components';
import tokens from '@ifood/pomodoro-tokens';
import styled from 'styled-components';

export const Container = styled(Flex)`
  font-size: ${tokens.fontSizes.s};
  font-family: ${tokens.font.family.ifood.body};
  line-height: ${tokens.lineHeights.m};
  color: ${tokens.colors.grayDarker};
  margin: ${tokens.space.regular} 0;

  p {
    margin-bottom: 0;
    display: flex;
    align-items: center;
  }

  em {
    font-style: normal;
  }

  a {
    font-family: ${tokens.font.family.ifood.body};
  }
`;
